import { useEffect } from 'react';
import { useAppOutdated } from '../lib/appVersion';

/*
 * Полоска «вышла новая версия». Сами страницу не перезагружаем: человек
 * может печатать сообщение или заполнять форму — решение за ним.
 *
 * Полоска занимает свою высоту, а не накрывает содержимое: класс на корне
 * приложения задаёт `--upd-bar-h`, и экраны, считающие высоту от окна (чат,
 * календарь, карта, график), вычитают её наравне с плашкой звонка. Пока
 * этого не было, чат оставался высотой ровно в окно, страница становилась
 * выше на высоту полоски, появлялась прокрутка и низ переписки с кнопкой
 * записи голосового уезжал за край.
 */
export function UpdateBar() {
  const outdated = useAppOutdated();

  useEffect(() => {
    if (!outdated) return;
    const app = document.getElementById('app');
    app?.classList.add('with-upd-bar');
    return () => app?.classList.remove('with-upd-bar');
  }, [outdated]);

  if (!outdated) return null;
  return (
    <div className="upd-bar">
      <span>Вышло обновление приложения</span>
      <button className="adm-btn mini edit" onClick={() => window.location.reload()}>
        Обновить
      </button>
    </div>
  );
}
